export default "__VITE_ASSET__BwNVImLR__"